module.exports = __webpack_public_path__ + "img/admin-icon.11f8bb6c.svg";